import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import Loader from "../../pages/Loader";

const AddTeamMember = () => {
  const [preview, setPreview] = React.useState(null);
  const [loading, setLoading] = useState(false);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPreview(URL.createObjectURL(file));
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const onSubmit = async (data) => {
    const formData = new FormData();
    setLoading(true);
    try {

      formData.append('file', data.photo[0]);
      formData.append('upload_preset', 'prayagproperties');

      const cloudinaryResponse = await fetch(
        'https://api.cloudinary.com/v1_1/djmyigser/image/upload',
        {
          method: 'POST',
          body: formData
        }
      );

      const cloudinaryData = await cloudinaryResponse.json();
      if (!cloudinaryData.secure_url) {
        throw new Error('Failed to upload image to Cloudinary');
      }


      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/admin/create_team`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          fullName: data.fullName,
          designation: data.designation,
          photo: cloudinaryData.secure_url,
        }),
      });

      const result = await response.json();


      if (response.ok && result.success) {
        Swal.fire({
          title: "Success!",
          text: "Team member added successfully.",
          icon: "success",
          confirmButtonColor: "#2563eb",
        });

        reset();
        setPreview(null);
      } else {
        Swal.fire({
          title: "Error",
          text: result.message || "Something went wrong.",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Upload error:", error);
      Swal.fire({
        title: "Error",
        text: "Failed to connect to server.",
        icon: "error",
      });
    }
    finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full min-h-[75vh] flex items-center justify-center bg-gray-100 px-4">
      <div className="w-full max-w-lg bg-white rounded-2xl shadow-lg p-6 sm:p-8">
        <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
          Add Team Member
        </h2>

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
          {/* Full Name */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Full Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Enter full name"
              {...register("fullName", { required: "Full Name is required" })}
              className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            {errors.fullName && (
              <p className="text-red-500 text-sm mt-1">
                {errors.fullName.message}
              </p>
            )}
          </div>

          {/* Designation */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Designation <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Enter designation"
              {...register("designation", {
                required: "Designation is required",
              })}
              className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            {errors.designation && (
              <p className="text-red-500 text-sm mt-1">
                {errors.designation.message}
              </p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Photo <span className="text-red-500">*</span>
            </label>
            <input
              type="file"
              accept="image/*"
              {...register("photo", {
                required: "Photo is required",
              })}
              onChange={handleImageChange}
              className="block w-full text-sm text-gray-600
               file:mr-4 file:py-2 file:px-4
               file:rounded-md file:border-0
               file:text-sm file:font-medium
               file:bg-blue-50 file:text-blue-700
               hover:file:bg-blue-100"
            />
            {errors.photo && (
              <p className="text-sm text-red-500 mt-1">
                {errors.photo.message}
              </p>
            )}
            {preview && (
              <div className="mt-4 flex justify-center sm:justify-start">
                <img
                  src={preview}
                  alt="Preview"
                  className="w-32 h-32 object-cover rounded-xl border shadow-md"
                />
              </div>
            )}
          </div>

          {/* Submit Button */}
          {/* <button
            type="submit"
            className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition duration-200"
          >
            Add Member
          </button> */}

          <div>
            <button
              type="submit"
              className="w-full bg-blue-600 hover:bg-blue-700 text-white text-sm sm:text-base font-semibold py-2 px-4 rounded-lg transition-colors flex items-center justify-center gap-2"
              disabled={loading}
            >
              {loading && (
                // <span className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                <Loader/>
              )}
              {loading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddTeamMember;
